var PRICE_ON_REQUEST_HULK_FORM_ID = '0kE71HKVYsngYYg_3tXXMQ';
// The form's only field, labelled exactly as in Hulk Form Builder.
var PRICE_ON_REQUEST_HULK_FIELD_LABEL = 'Price Request Received';
// Folk Objects' shop id in Hulk Form Builder (window.hulkFormBuilder.shop_data).
var PRICE_ON_REQUEST_HULK_SHOP_UUID = 'JKxsGr_fFLf3rouCAaJYcg';
var PRICE_ON_REQUEST_HULK_ENDPOINT = 'https://formbuilder.hulkapps.com/ajaxcall/formresponse';
var PRICE_ON_REQUEST_GEO_ENDPOINT = 'https://ipwho.is/';
// IP-only fallback for when the geo lookup fails (e.g. ipwho.is rate limit).
var PRICE_ON_REQUEST_IP_ENDPOINT = 'https://api.ipify.org?format=json';
var PRICE_ON_REQUEST_LOOKUP_TIMEOUT_MS = 4000;
// Floating chat button injected by the WhatsApp app embed (dondy-whatsapp).
var PRICE_ON_REQUEST_WIDGET_SELECTOR = '#whatsapp-widget-root a';

document.addEventListener('click', function (event) {
  var button = event.target.closest('.price-on-request-button');
  if (!button) return;

  var title = button.getAttribute('data-product-title') || document.title;
  var url = button.getAttribute('data-product-url') || window.location.href;

  priceOnRequestVisitorText().then(function (visitor) {
    var message =
      'A customer requested pricing for "' +
      title +
      '" and has been sent to WhatsApp. Product link: ' +
      url +
      '. IP: ' +
      visitor;

    submitHulkForm(message);
  });
});

// The WhatsApp widget isn't tied to a product, so it sends only the visitor's
// IP and location. Capture phase, so it still runs if the app's widget stops
// the click from bubbling.
document.addEventListener(
  'click',
  function (event) {
    if (!event.target.closest(PRICE_ON_REQUEST_WIDGET_SELECTOR)) return;
    priceOnRequestVisitorText().then(submitHulkForm);
  },
  true
);

// Resolves with "IP (city, region, country)"; if the geo lookup fails, the IP
// comes from the fallback lookup and the location reads "location unavailable".
function priceOnRequestVisitorText() {
  return priceOnRequestFetchGeo().then(function (geo) {
    var ipPromise = geo && geo.ip ? Promise.resolve(geo.ip) : priceOnRequestFetchIp();

    return ipPromise.then(function (ip) {
      var locationParts = geo
        ? [geo.city, geo.region, geo.country].filter(Boolean)
        : [];
      var locationText = locationParts.length
        ? locationParts.join(', ')
        : 'location unavailable';

      return (ip || 'unknown') + ' (' + locationText + ')';
    });
  });
}

var priceOnRequestGeoPromise = null;
var priceOnRequestIpPromise = null;

function priceOnRequestFetchGeo() {
  if (priceOnRequestGeoPromise) return priceOnRequestGeoPromise;

  priceOnRequestGeoPromise = priceOnRequestFetchJson(PRICE_ON_REQUEST_GEO_ENDPOINT, 'Geo').then(
    function (data) {
      if (data && data.success === false) {
        console.warn('[price-on-request] Geo lookup unsuccessful.', data);
        return null;
      }
      return data;
    }
  );

  return priceOnRequestGeoPromise;
}

function priceOnRequestFetchIp() {
  if (priceOnRequestIpPromise) return priceOnRequestIpPromise;

  priceOnRequestIpPromise = priceOnRequestFetchJson(PRICE_ON_REQUEST_IP_ENDPOINT, 'IP').then(
    function (data) {
      return (data && data.ip) || null;
    }
  );

  return priceOnRequestIpPromise;
}

// Resolves with the parsed JSON, or null on error or timeout.
function priceOnRequestFetchJson(url, label) {
  return new Promise(function (resolve) {
    var settled = false;
    var timeoutId = setTimeout(function () {
      if (settled) return;
      settled = true;
      console.warn('[price-on-request] ' + label + ' lookup timed out.');
      resolve(null);
    }, PRICE_ON_REQUEST_LOOKUP_TIMEOUT_MS);

    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        console.log('[price-on-request] ' + label + ' lookup resolved:', data);
        resolve(data);
      })
      .catch(function (error) {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        console.warn('[price-on-request] ' + label + ' lookup failed.', error);
        resolve(null);
      });
  });
}

function priceOnRequestPrefetchGeo(event) {
  if (!event.target.closest('.price-on-request-button, ' + PRICE_ON_REQUEST_WIDGET_SELECTOR)) return;
  priceOnRequestFetchGeo();
}

document.addEventListener('pointerover', priceOnRequestPrefetchGeo);
document.addEventListener('touchstart', priceOnRequestPrefetchGeo, {
  passive: true,
});

// Hulk validates utm_params and referrer_url against the shop's Hulk plan
// (Folk Objects' plan has utm-tracking and referrer recording), so they're
// filled in the same way Hulk's own submit code does.
function priceOnRequestHulkPlanHas(feature) {
  var hulk = window.hulkFormBuilder || {};
  var features =
    (hulk.features_data &&
      hulk.features_data.shop_plan_features &&
      hulk.features_data.shop_plan_features.shop_plan_features) ||
    (hulk.plan_features && hulk.plan_features.shop_plan_features) ||
    [];
  return features.indexOf(feature) !== -1;
}

function priceOnRequestUtmParams() {
  var params = {};
  new URLSearchParams(window.location.search).forEach(function (value, key) {
    if (key.indexOf('utm_') === 0) params[key] = value;
  });
  return JSON.stringify(params);
}

// Sends the same request Hulk's own app embed sends when it renders a form
// on the page (hulkFBPostFormResponse in its extra-functions.js). Posting it
// directly avoids the hidden form, which Hulk now loads in a cross-origin
// iframe that the page can't fill in.
function submitHulkForm(message) {
  var formResponse = {};
  formResponse[PRICE_ON_REQUEST_HULK_FIELD_LABEL] = message;

  console.log('[price-on-request] Submitting Hulk form with message:', message);

  fetch(PRICE_ON_REQUEST_HULK_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shop-UUID': PRICE_ON_REQUEST_HULK_SHOP_UUID,
    },
    body: JSON.stringify({
      form_uuid: PRICE_ON_REQUEST_HULK_FORM_ID,
      formResponse: JSON.stringify(formResponse),
      confirmationMail: true,
      email_check: '',
      utm_params: priceOnRequestHulkPlanHas('utm-tracking') ? priceOnRequestUtmParams() : null,
      referrer_url: priceOnRequestHulkPlanHas('on-form-submission-record-the-referrer-url')
        ? window.location.href
        : null,
    }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    })
    .then(function (data) {
      // Hulk reports validation failures as HTTP 200 with an Error field.
      if (data && data.Error) throw new Error(data.Error);
      console.log('[price-on-request] Hulk form submitted:', data);
    })
    .catch(function (error) {
      console.warn('[price-on-request] Hulk form submission failed.', error);
    });
}
